import React from 'react';
import { SelectContainer, FilterSelect, SelectIcon } from './FilterBar.styled';

const SortDropdown = ({ options, activeId, onChange }) => {
    return (
        <SelectContainer>
            <FilterSelect
                value={activeId}
                onChange={(e) => onChange(e.target.value)}
                aria-label="Ordenar productos"
            >
                {options.map(option => (
                    <option key={option.id} value={option.id}>
                        {option.label}
                    </option>
                ))}
            </FilterSelect>
            <SelectIcon>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="m6 9 6 6 6-6" />
                </svg>
            </SelectIcon>
        </SelectContainer>
    );
};

export default SortDropdown;
